export default {
  PageFacturae: {
    // Headers and titles
    rectificative_invoice_title: 'FACTURA RECTIFICATIVA',
    rectifies_invoice: 'Rectifica la factura {invoiceNumber} de {invoiceDate}',
    substitution_invoice_title: 'FACTURA SUBSTITUTIVA',
    substitutes_simplified_invoice: 'Substitueix la factura simplificada amb número i sèrie {invoiceNumber}.',
    simplified_invoice_issue_date: 'Data d\'expedició de la factura simplificada: {invoiceDate}.',
    rectificative_reason_default: 'Motiu: Factura rectificativa per diferències.',
    draft_watermark: 'ESBORRANY',

    // QR and verification
    qr_label: 'QR tributari:',
    qr_verifiable: 'Factura verificable a la seu electrònica de l\'AEAT',

    // Invoice numbers and dates
    invoice_number_label: 'Número {documentType}: ',
    external_invoice_number: 'Número factura extern: ',
    invoice_date_label: 'Data {documentType}: ',
    due_date: 'Data de venciment: ',
    operation_date: 'Data operació: ',
    start_date: 'Data inici: ',
    end_date: 'Data final: ',
    signing_date: 'Data signatura: ',

    // Supplier section
    issuer: 'Emissor',
    self_billing_notice: 'Facturació pel destinatari',
    business_name: 'Raó social: ',
    fiscal_name: 'Nom fiscal: ',
    fiscal_address: 'Domicili fiscal: ',
    nif_cif: 'NIF/CIF: ',
    bank_account: 'Número de compte: ',
    trade_name: 'Nom comercial: ',
    email_label: 'Correu electrònic: ',
    phone_label: 'Telèfon:',
    website_label: 'Web:',

    // Customer section
    receiver: 'Receptor',
    dire_label: 'DIRe:',
    accounting_office: 'Despatx comptable:',
    management_body: 'Òrgan de gestió:',
    processing_unit: 'Unitat tramitadora:',
    proposing_body: 'Òrgan proponent:',

    // Details section
    details: 'Detalls',
    details_of_budget: 'del pressupost',
    details_of_delivery_note: 'de l\'albarà',
    details_of_proforma: 'de la proforma',
    details_of_ticket: 'del tiquet',
    details_of_invoice: 'de la factura',

    // Table headers
    description: 'Descripció',
    total: 'Total',
    quantity: 'Quantitat',
    unit_price: 'Preu unitari',
    discount: 'Descompte',
    discount_percentage: 'Descompte %',
    withholding: 'Retenció',
    total_without_tax: 'Total (sense {taxType})',

    // Document type headers
    proforma_label: 'Proforma',
    budget_label: 'Pressupost',
    delivery_note_label: 'Albarà',
    date_of_proforma: 'Data de la proforma: ',
    date_of_budget: 'Data del pressupost: ',
    date_of_delivery_note: 'Data de l\'albarà: ',
    file_reference: 'Expedient',
    file_date: 'Data de l\'expedient: ',
    client_reference: 'Referència del client',

    // Totals section
    total_without_discounts: 'Total sense descomptes',
    line_discount: 'Descompte per línia',
    global_discount: 'Descompte global',
    total_without_taxes: 'Total sense impostos',
    total_withholding: 'Total Retenció',
    equivalence_surcharge_short: 'RE',
    total_document: 'Total {documentType}',
    withholding_label: 'Retenció: ',
    reimbursable_label: 'Suplert: ',
    total_to_pay: 'Total a pagar',

    // Document types for dynamic text
    invoice: 'Factura',
    budget: 'Pressupost',
    delivery_note: 'Albarà',
    proforma: 'Proforma',
    ticket: 'Tiquet',

    // Footer
    page_number: 'Pàgina {currentPage} de {totalPages}',
    document_info: 'Número {documentType}: {invoiceNumber} ({invoiceDate})',

    // Tax exemption reasons (IVA)
    tax_reason_isp: 'Inversió del subjecte passiu en virtut de l\'art 84.Uno de la Llei 37/1992, de l\'IVA.',
    tax_reason_ns: 'Operació no subjecta a IVA en virtut de l\'art. 7 de la Llei 37/1992, de l\'IVA.',
    tax_reason_ex: 'Operació exempta en virtut de l\'art. 20 de la Llei 37/1992, de l\'IVA.',
    tax_reason_nsrl: 'Operació no subjecta a IVA per regles de localització en virtut de l\'art. 69 de la Llei 37/1992, de l\'IVA.',
    tax_reason_intra_bie: 'Lliurament intracomunitari exempt en virtut de l\'art. 25 de la Llei 37/1992, de l\'IVA.',
    tax_reason_intra_ser: 'Operació no subjecta a IVA en virtut de l\'art. 69 de la Llei 37/1992, de l\'IVA. Inversió del subjecte passiu conforme a la Directiva 2006/112/CE.',
    tax_reason_export: 'Operació exempta per exportació en virtut de l\'art. 21 de la Llei 37/1992, de l\'IVA.',
    // Tax exemption reasons (IGIC)
    tax_reason_igic_art50: 'Operació exempta d\'IGIC en virtut de l\'Art. 50 de la Llei 4/2012.',
    tax_reason_igic_art11: 'Operació exempta d\'IGIC en virtut de l\'Art. 11 de la Llei 20/1991.',
    tax_reason_igic_art12: 'Operació exempta d\'IGIC en virtut de l\'Art. 12 de la Llei 20/1991.',
    tax_reason_igic_art13: 'Operació exempta d\'IGIC en virtut de l\'Art. 13 de la Llei 20/1991.',
    tax_reason_igic_art25: 'Operació exempta d\'IGIC en virtut de l\'Art. 25 de la Llei 19/1994.',
    tax_reason_igic_art47: 'Operació exempta d\'IGIC en virtut de l\'Art. 47 de la Llei 19/1994.',
    tax_reason_igic_art110: 'Operació exempta d\'IGIC en virtut de l\'Art. 110 de la Llei 4/2012.',
    tax_reason_igic_otros: 'Operació exempta d\'IGIC.',

    // Payment methods
    payment_means_01: 'Pagament al comptat',
    payment_means_02: 'Pagament per rebut domiciliat',
    payment_means_03: 'Pagament per rebut',
    payment_means_04: 'Pagament per transferència',
    payment_means_05: 'Pagament per lletra acceptada',
    payment_means_06: 'Pagament per crèdit documentari',
    payment_means_07: 'Pagament per contracte d\'adjudicació',
    payment_means_08: 'Pagament per lletra de canvi',
    payment_means_09: 'Pagament per pagaré a l\'ordre',
    payment_means_10: 'Pagament per pagaré no a l\'ordre',
    payment_means_11: 'Pagament per xec',
    payment_means_12: 'Pagament per reposició',
    payment_means_13: 'Pagament per mitjans especials',
    payment_means_14: 'Pagament per compensació',
    payment_means_15: 'Pagament per gir postal',
    payment_means_16: 'Pagament per xec conformado',
    payment_means_17: 'Pagament per xec bancari',
    payment_means_18: 'Pagament contra reemborsament',
    payment_means_19: 'Pagament amb targeta',
    payment_means_13_1: 'Pagament per PayPal',
    payment_means_13_2: 'Pagament per Confirming',
  }
}
